function normalizeStepOptions(shouldSkipOrOptions) {
  if (!shouldSkipOrOptions) {
    return undefined;
  }
  if (typeof shouldSkipOrOptions === 'function') {
    return {
      shouldSkip: shouldSkipOrOptions
    };
  }
  return shouldSkipOrOptions;
}
export function createFlow() {
  const flow = [];
  const builder = {
    step(id, component, params, shouldSkipOrOptions) {
      const options = normalizeStepOptions(shouldSkipOrOptions);
      flow.push({
        type: 'step',
        id,
        component,
        params,
        shouldSkip: options == null ? void 0 : options.shouldSkip,
        meta: options == null ? void 0 : options.meta
      });
      return builder;
    },
    action(id, handler) {
      flow.push({
        type: 'action',
        id,
        handler: handler
      });
      return builder;
    },
    task(id, handler) {
      flow.push({
        type: 'task',
        id,
        handler
      });
      return builder;
    },
    build() {
      return [...flow];
    }
  };
  return builder;
}
//# sourceMappingURL=createFlow.js.map